import { useQuery } from "@tanstack/react-query";
import type { ServiceTemplate } from "../../types";
import { serviceTemplateService } from "../../services/serviceTemplatesService";

export const useServiceTemplate = (serviceTemplateId?: string) => {
  return useQuery<ServiceTemplate>({
    enabled: Boolean(serviceTemplateId),
    queryKey: ["service-template", serviceTemplateId],
    retry: false,
    queryFn: async () => {
      const template = await serviceTemplateService.get(serviceTemplateId!);
      if (!template) {
        throw new Error(`Service template with id "${serviceTemplateId}" not found`);
      }
      return template;
    },
  });
};
